module.exports = __webpack_public_path__ + "img/flat collar width.aa90b079.png";